export default __webpack_public_path__ + "static/media/fractures.98ccd0bc.png";